<template>
    <div class="news-ticker">
        <div class="ticker-display">
            <div class="news-label">{{ $t('newsTicker') }}</div>
            <NewsTickerItem v-if="currentNewsItem" :key="currentNewsItem.id" :value="currentNewsItem" />
        </div>
        <div class="all-news-popup">
            <transition-group>
                <NewsTickerItem v-for="item in allNewsItems" :key="item.id" :value="item" />
            </transition-group>
        </div>
    </div>
</template>

<script>
    import NewsTickerItem from "./NewsTickerItem";
    import { clearInterval } from "timers";
    import axios from 'axios';
    import config from "@/appdata/config.json";

    export default {
        components: {
            NewsTickerItem
        },
        data() {
            return {
                currentNewsIndex: 0,
                intervalId: null,
                allNewsItems: []
            };
        },
        computed: {
            currentNewsItem() {
                return this.allNewsItems[this.currentNewsIndex];
            }
        },
        mounted() {
            this.currentNewsIndex = Math.round(
                Math.random() * (this.allNewsItems.length - 1)
            );
            const url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/News"
            this.startTickerTimer();
            axios.get(url, {
             })
                .then(response => {
                    this.allNewsItems = response.data;
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                })
                .finally(() => this.loading = false)
        },
        beforeDestroy() {
            this.stopTickerTimer();
        },
        methods: {
            startTickerTimer() {
                this.stopTickerTimer();
                this.intervalId = setInterval(this.timerTick, 10000);
            },
            stopTickerTimer() {
                if (this.intervalId) clearInterval(this.intervalId);
                this.intervalId = null;
            },
            timerTick() {
                this.currentNewsIndex =
                    (this.currentNewsIndex + 1) % this.allNewsItems.length;
            }
        }
    };
</script>

<style>
    @import '../css/main.css';
</style>